"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationTab = exports.InstallationTab = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _PanelItems = require("../PanelItems");

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _Message = require("../../../ui-components/Message");

var _OauthInstallationPanel = require("./OauthInstallationPanel");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _FederatedSearchIntegrationPanel = _interopRequireDefault(require("./FederatedSearchIntegrationPanel"));

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _CrmImportIntegrationPanel = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/salesforce/CrmImportIntegrationPanel"));

var _constants = require("@insided/shared/constants");

var IntegrationTab = function IntegrationTab(_ref) {
  var activePanel = _ref.activePanel,
      isInstalled = _ref.isInstalled,
      isProduction = _ref.isProduction,
      isSandbox = _ref.isSandbox,
      isSandboxSyncAllowed = _ref.isSandboxSyncAllowed,
      instanceType = _ref.instanceType,
      hasUnsavedChanges = _ref.hasUnsavedChanges,
      showUnsavedChangesModal = _ref.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref.displayUnsavedChangedModal,
      _closeModal = _ref.closeModal,
      _resetChanges = _ref.resetChanges,
      storedState = _ref.storedState,
      onClickPanelCallback = _ref.onClickPanelCallback,
      isCaseEscalationEnabled = _ref.isCaseEscalationEnabled,
      isCaseCreationEnabled = _ref.isCaseCreationEnabled,
      saveCaseCreationSetting = _ref.saveCaseCreationSetting,
      resetCaseCreationSetting = _ref.resetCaseCreationSetting,
      onCaseCreationSettingChanged = _ref.onCaseCreationSettingChanged,
      showCaseCreationActionButtons = _ref.showCaseCreationActionButtons,
      isCrmExportIntegrationEnabled = _ref.isCrmExportIntegrationEnabled,
      isCrmExportEnabled = _ref.isCrmExportEnabled,
      saveCrmExportSetting = _ref.saveCrmExportSetting,
      resetCrmExportSetting = _ref.resetCrmExportSetting,
      onCrmExportSettingChanged = _ref.onCrmExportSettingChanged,
      showCrmExportActionButtons = _ref.showCrmExportActionButtons,
      isCrmImportIntegrationEnabled = _ref.isCrmImportIntegrationEnabled,
      isCrmImportEnabled = _ref.isCrmImportEnabled,
      saveCrmImportSetting = _ref.saveCrmImportSetting,
      resetCrmImportSetting = _ref.resetCrmImportSetting,
      onCrmImportSettingChanged = _ref.onCrmImportSettingChanged,
      showCrmImportActionButtons = _ref.showCrmImportActionButtons,
      fieldApiName = _ref.fieldApiName,
      valueApiName = _ref.valueApiName,
      onCrmImportMappingFieldApiNameChanged = _ref.onCrmImportMappingFieldApiNameChanged,
      onCrmImportMappingPicklistValueChanged = _ref.onCrmImportMappingPicklistValueChanged,
      errorFields = _ref.errorFields,
      isFederatedSearchIntegrationEnabled = _ref.isFederatedSearchIntegrationEnabled,
      isFederatedSearchEnabled = _ref.isFederatedSearchEnabled,
      isFederatedSearchCustomDomainEnabled = _ref.isFederatedSearchCustomDomainEnabled,
      federatedSearchLocale = _ref.federatedSearchLocale,
      federatedSearchCustomDomain = _ref.federatedSearchCustomDomain,
      federatedSearchChannel = _ref.federatedSearchChannel,
      toggleCustomDomainField = _ref.toggleCustomDomainField,
      setCustomDomainField = _ref.setCustomDomainField,
      setChannelField = _ref.setChannelField,
      showFederatedSearchActionButtons = _ref.showFederatedSearchActionButtons,
      saveFederatedSearchSetting = _ref.saveFederatedSearchSetting,
      resetFederatedSearchSetting = _ref.resetFederatedSearchSetting,
      onFederatedSearchSettingChanged = _ref.onFederatedSearchSettingChanged,
      onFederatedSearchLocaleClicked = _ref.onFederatedSearchLocaleClicked,
      onFederatedSearchDomainClicked = _ref.onFederatedSearchDomainClicked,
      federatedSearchInitialSyncCompleted = _ref.federatedSearchInitialSyncCompleted,
      isSavingCrmImportSetting = _ref.isSavingCrmImportSetting,
      isSavingCrmExportSetting = _ref.isSavingCrmExportSetting,
      isSavingCaseCreationSetting = _ref.isSavingCaseCreationSetting,
      isSavingFederatedSearchSetting = _ref.isSavingFederatedSearchSetting;
  var CrmImportIntegrationPanel = (0, _CrmImportIntegrationPanel.default)({
    isInstalled: isInstalled,
    isProduction: isProduction,
    isSandbox: isSandbox,
    isSandboxSyncAllowed: isSandboxSyncAllowed,
    instanceType: instanceType,
    isSettingEnabled: isCrmImportEnabled,
    onSettingChanged: onCrmImportSettingChanged,
    onSave: saveCrmImportSetting,
    onCancel: resetCrmImportSetting,
    showActionButtons: showCrmImportActionButtons,
    storedState: storedState,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanelCallback: onClickPanelCallback,
    fieldApiName: fieldApiName,
    valueApiName: valueApiName,
    onCrmImportMappingFieldApiNameChanged: onCrmImportMappingFieldApiNameChanged,
    onCrmImportMappingPicklistValueChanged: onCrmImportMappingPicklistValueChanged,
    isLoading: isSavingCrmImportSetting
  });
  var FederatedSearchIntegrationPanel = (0, _FederatedSearchIntegrationPanel.default)({
    isInstalled: isInstalled,
    isSettingEnabled: isFederatedSearchEnabled,
    isCustomDomainEnabled: isFederatedSearchCustomDomainEnabled,
    customDomain: federatedSearchCustomDomain,
    channel: federatedSearchChannel,
    toggleCustomDomainField: toggleCustomDomainField,
    setCustomDomainField: setCustomDomainField,
    setChannelField: setChannelField,
    onSave: saveFederatedSearchSetting,
    onCancel: resetFederatedSearchSetting,
    onSettingChanged: onFederatedSearchSettingChanged,
    showActionButtons: showFederatedSearchActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanelCallback: onClickPanelCallback,
    storedState: storedState,
    errorFields: errorFields,
    federatedSearchLocale: federatedSearchLocale,
    onFederatedSearchLocaleClicked: onFederatedSearchLocaleClicked,
    onFederatedSearchDomainClicked: onFederatedSearchDomainClicked,
    federatedSearchInitialSyncCompleted: federatedSearchInitialSyncCompleted,
    isLoading: isSavingFederatedSearchSetting
  });
  var CrmExportIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Export community member & activity data to Salesforce',
    isInstalled: isInstalled,
    imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    imageToName: 'salesforce-s',
    isSettingEnabled: isCrmExportEnabled,
    onSettingChanged: onCrmExportSettingChanged,
    onSave: saveCrmExportSetting,
    onCancel: resetCrmExportSetting,
    showActionButtons: showCrmExportActionButtons,
    toggleLabel: 'Automatically export community data to Salesforce',
    communityArticleLink: 'https://community.insided.com/integrations-124/how-to-set-up-the-insided-x-salesforce-crm-integration-faq-1917',
    description: "Get a 360 view of your customers, enable custom workflows, and gain deeper insights by exporting ".concat(_constants.PLATFORM_BRAND_NAME, " community member and activity data to Salesforce."),
    additionalHelpText: 'Go to your Salesforce instance and start building custom page layouts, workflows, reports and dashboards using community member and activity data.',
    storedIsSettingEnabled: storedState.isCrmExportEnabled,
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: 'integration__panel qa-crm-export',
    onClickPanel: onClickPanelCallback,
    isLoading: isSavingCrmExportSetting
  });
  var CaseCreationIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Create Salesforce cases from community posts',
    isInstalled: isInstalled,
    imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    imageToName: 'salesforce-s',
    isSettingEnabled: isCaseCreationEnabled,
    onSettingChanged: onCaseCreationSettingChanged,
    onSave: saveCaseCreationSetting,
    onCancel: resetCaseCreationSetting,
    showActionButtons: showCaseCreationActionButtons,
    toggleLabel: 'Enable moderators to create Salesforce tickets',
    communityArticleLink: 'https://community.insided.com/integrations-124/how-to-set-up-the-insided-x-salesforce-case-escalation-integration-2072',
    description: 'Create a Salesforce case from any user-generated content (questions, conversations, ideas, replies) via Control.',
    additionalHelpText: (0, _preact.h)("span", null, "Open a topic from the", ' ', (0, _preact.h)("a", {
      className: "overview-page-link",
      target: "_blank",
      rel: "noreferrer",
      href: (0, _absoluteUrlRuntime.resolveUrl)("/overview")
    }, "content overview"), ' ', "and click the Salesforce logo next to any user-generated content to create a ticket."),
    storedIsSettingEnabled: storedState.isCaseCreationEnabled,
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: 'integration__panel qa-case-creation',
    onClickPanel: function onClickPanel(selectedPanel) {
      return onClickPanelCallback(selectedPanel);
    },
    isLoading: isSavingCaseCreationSetting
  });
  var enabledIntegrations = [];

  if (isCrmImportIntegrationEnabled) {
    enabledIntegrations.push(CrmImportIntegrationPanel);
  }

  if (isCrmExportIntegrationEnabled) {
    enabledIntegrations.push(CrmExportIntegrationPanel);
  }

  if (isCaseEscalationEnabled) {
    enabledIntegrations.push(CaseCreationIntegrationPanel);
  }

  if (isFederatedSearchIntegrationEnabled) {
    enabledIntegrations.push(FederatedSearchIntegrationPanel);
  }

  return (0, _preact.h)("div", {
    className: "integration__tab"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: activePanel,
    panels: enabledIntegrations,
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  }), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal();
    },
    resetChanges: function resetChanges() {
      return _resetChanges();
    }
  }));
};

exports.IntegrationTab = IntegrationTab;

var InstallationTab = function InstallationTab(_ref2) {
  var isInstalled = _ref2.isInstalled,
      isProduction = _ref2.isProduction,
      instanceTypes = _ref2.instanceTypes,
      _onSave = _ref2.onSave,
      type = _ref2.type,
      username = _ref2.username,
      instanceUrl = _ref2.instanceUrl,
      appConsumerKey = _ref2.appConsumerKey,
      isOauthEnabled = _ref2.isOauthEnabled,
      _onClickManage = _ref2.onClickManage,
      _onClickUninstall = _ref2.onClickUninstall,
      _onInstanceTypeChangeCallback = _ref2.onInstanceTypeChangeCallback,
      hasUnsavedChanges = _ref2.hasUnsavedChanges,
      showUnsavedChangesModal = _ref2.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref2.displayUnsavedChangedModal,
      _closeModal2 = _ref2.closeModal,
      _resetChanges2 = _ref2.resetChanges;
  var InstallationPanel = {
    body: (0, _preact.h)(_OauthInstallationPanel.InstallationPanelBody, {
      isInstalled: isInstalled,
      isProduction: isProduction,
      onSave: function onSave() {
        return _onSave();
      },
      instanceTypes: instanceTypes,
      type: type,
      username: username,
      instanceUrl: instanceUrl,
      appConsumerKey: appConsumerKey,
      isOauthEnabled: isOauthEnabled,
      onClickManage: function onClickManage() {
        return _onClickManage();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall();
      },
      onInstanceTypeChangeCallback: function onInstanceTypeChangeCallback(value) {
        return _onInstanceTypeChangeCallback(value);
      }
    }),
    customClass: 'panel__body_without_header',
    hasUnsavedChanges: hasUnsavedChanges
  };
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [InstallationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  })), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal2();
    },
    resetChanges: function resetChanges() {
      return _resetChanges2();
    }
  }), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to install the Salesforce integration step by step",
    url: "https://community.insided.com/integrations-124/how-to-install-the-salesforce-x-insided-integrations-3932",
    isExternalLinkForToggle: false
  }));
};

exports.InstallationTab = InstallationTab;